import eDate from 'js/date';
let renov = new Date();
renov.setFullYear(renov.getFullYear() + 1);
export default {
	cnpj: '',
	data: eDate(new Date(), 'YY-MM-DD'),
	renovacao: eDate(renov, 'YY-MM-DD'),
	cod_vendedor: '',
	cod_categoria: '',
	cod_tipprop: '',
	forma_pagamento: 'DINHEIRO',
	list_services: [],
	dia_pagamento: '',
	regiao: '',
	parcelas: 1,
	acrescimo: 0.0,
	desconto: 0.0,
	status: '',
	new: true,
};



// WEBPACK FOOTER //
// ./src/components/proposals/javascript/reset.js